<template>
  <b-modal
    id="xoa-quyen-theo-nguoi-dung"
    centered
    hide-footer
    size="md"
    header-class="border-bottom-none"
    footer-class="border-top-none"
    :title="`Bạn có chắc chắn xóa phạm vi của quyền \'${permissionName}\'?`"
  >
    <div class="d-flex justify-content-end">
      <base-button button="Xóa" class="btn btn-main ml-2" @click="submit()">
      </base-button>
      <base-button button="Hủy" class="btn btn-line" @click="hideModal()">
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { ROUTE_NAME } from "@/constants/constants";

export default {
  name: "XoaQuyenTrongQuyenTrongVaiTroModal",
  props: {
    deletePermissionIds: {
      type: Array,
      required: true,
    },
    permissionName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      emailSelected: 1,
      modalTitle: "",
      internalForm: {},
    };
  },
  watch: {
    form: {
      handler() {
        this.internalForm = this.form;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-quyen-theo-nguoi-dung");
    },
    submit() {
      this.$emit("xoaQuyen");
    },
  },
};
</script>
<style lang="scss">
#xoa-quyen-theo-nguoi-dung .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>